var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38175 8.1941L7.12034 5.30919L3.95715 4.03254L3 5.12858L4.56794 8.23196L7.38175 8.1941ZM7.38175 8.1941L10.5753 11.1506M12.1377 15.24L17.8151 20.4961C18.5989 21.2218 19.8058 21.1558 20.5106 20.3487C21.2154 19.5416 21.1513 18.299 20.3675 17.5733L15.3998 12.9743M17.9492 3.4415C16.1031 2.57427 13.8495 2.99229 12.4209 4.62818C11.0977 6.14339 10.8585 8.27253 11.6513 10.0074C11.5232 10.096 11.4035 10.2022 11.2956 10.3258L4.91458 17.6327C4.20976 18.4398 4.27384 19.6824 5.05771 20.4081C5.84159 21.1338 7.04842 21.0678 7.75325 20.2607L14.1343 12.9538C14.2422 12.8302 14.332 12.6965 14.4041 12.5559C16.1635 13.1839 18.1944 12.7135 19.5176 11.1983C20.9462 9.56236 21.1113 7.21084 20.0782 5.41252L17.0338 8.89874L14.9048 6.92772L17.9492 3.4415Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.97b9ce71e637b487edaaab3a109ac506.svg";
export { ForwardRef as ReactComponent };